import { render, staticRenderFns } from "./VsfShippingProvider.vue?vue&type=template&id=6e6dd8e2&scoped=true"
import script from "./VsfShippingProvider.vue?vue&type=script&lang=js"
export * from "./VsfShippingProvider.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./VsfShippingProvider.vue?vue&type=style&index=0&id=6e6dd8e2&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./VsfShippingProvider.vue?vue&type=style&index=1&id=6e6dd8e2&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6e6dd8e2",
  "44c21f20"
  
)

export default component.exports